export default "__VITE_ASSET__B_X1iCmO__"